/* apps/viewer/src/app/toc-items/comments-module/comment-edit/comment-edit.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
:host {
  display: block;
  font-size: 14px;
  margin-bottom: 10px;
  width: 100%;
}
.comment-header {
  align-items: start;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.comment-header .mat-icon {
  height: 24px;
  margin-right: 10px;
  width: 24px;
}
.comment-priority {
  align-items: center;
  display: flex;
  margin-bottom: 5px;
  margin-right: 20px;
}
.comment-priority mat-select {
  align-items: center;
  display: flex;
  font-size: 14px;
  max-width: 120px;
}
.comment-priority mat-select ::ng-deep .mat-mdc-select-value {
  margin-right: 10px;
}
.comment-code-input {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.comment-code-input input {
  height: 25px;
  text-transform: uppercase;
  width: 90px;
}
.comment-code-input input:focus-visible {
  outline-color: #596643;
}
.comment-code-input .hint-top {
  font-size: 10px;
  margin-bottom: 2px;
}
.comment-form-fields {
  display: flex;
  flex-direction: column;
}
.comment-paragraphs-form-fields {
  display: flex;
  flex-direction: column;
}
.comment-paragraphs-form-fields mat-form-field {
  margin-bottom: -8px;
  margin-top: -8px;
}
.paragraphs-action {
  display: flex;
  gap: 10px;
  justify-content: start;
  margin: 10px 0 20px;
}
.form-action {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.form-action .cancel-button {
  margin-right: 10px;
}
.medias-panel {
  flex-grow: 1;
  font-size: 14px;
  margin: 0;
  padding-inline-start: 20px;
}
.medias-panel button {
  height: 35px;
  padding: 0;
}
.media-link {
  cursor: pointer;
  margin-right: 10px;
  text-decoration: underline;
  word-break: break-word;
}
.media-list-item {
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 48px;
}
.info {
  display: flex;
  flex-wrap: wrap;
}
.info .key {
  flex: 0 0 200px;
  font-weight: bold;
  width: 200px;
}
.info .value {
  flex: 1;
  min-width: 220px;
}
/*# sourceMappingURL=comment-edit.component.css.map */
